var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import propTypes from 'prop-types';
import { jsx } from 'theme-ui';
import View from '../View/View';
const tags = {
    default: 'div',
};
/** @type {import('theme-ui').ThemeUIStyleObject} */
const nowrapStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};
export default function Label(_a) {
    var { variant = 'default', as = tags[variant] || tags.default, nowrap = false, children } = _a, rest = __rest(_a, ["variant", "as", "nowrap", "children"]);
    return (jsx(View, Object.assign({ as: as, sx: Object.assign({ variant: `label.${variant}` }, (nowrap && nowrapStyle)) }, rest), children));
}
Label.propTypes = {
    /**
     * The style variant.
     */
    variant: propTypes.oneOf(['default', 'large', 'small']),
    /**
     * The tag to use.
     * */
    as: propTypes.elementType,
    /**
     * The label text or content.
     */
    children: propTypes.node,
};
//# sourceMappingURL=Label.js.map